import { v as vop, V as compileG, w as compile, l as defOp, W as NEW_OUT, X as SET } from './codegen-df7bb22c.js';

const $ = (dim) => magSq.add(dim, compile(dim, ([a]) => `${a}*${a}`, "a", "a", "", "+", "return ", ";"));
const magSq = vop();
magSq.default(compileG(([a]) => `sum+=${a}*${a};`, "a", undefined, "sum", "let sum=0;"));
const magSq2 = $(2);
const magSq3 = $(3);
const magSq4 = $(4);

const [set, set2, set3, set4] = defOp(SET, "o,a", undefined, "o", 1, NEW_OUT);

export { set2 as a, set3 as b, magSq as c, magSq2 as m, set as s };
